module.exports = ".background {\r\n\tbackground: #431462;\r\n}"